<div class="c-modal-dialog modal-container">
  <div class="content-wrapper">
    <h2>Submission Errors</h2>
    <p class="subheading">
      Your designations failed to be submitted due to the following Priority
      Policy violations
    </p>
    <div
      *ngIf="
        (validationError$ | async)
          ?.priorityRuleValidationErrors as validationErrors
      "
    >
      <ng-container *ngFor="let validationError of validationErrors">
        <p class="rule-text">
          <span *ngIf="validationError.allotmentNumbers.length !== 0"
            >LM Allot #{{
              validationError.allotmentNumbers.join(', #')
            }}: </span
          >{{ validationError.ruleText }}
        </p>
      </ng-container>
    </div>
  </div>
  <div class="btn-wrapper">
    <button
      type="button"
      class="c-btn c-btn-primary rounded"
      (click)="closeModal()"
    >
      Continue Working
    </button>
  </div>
</div>
